// 仓储资源模拟数据
export const storageResources = [
  {
    id: 1,
    type: '市场集货仓',
    location: '广州白云',
    capabilities: ['支持多主体货权', '支持无进项货物', '可配合1039报关', '可出具规范出仓记录'],
    description: '专为批发市场商户设计，支持多供应商集货'
  },
  {
    id: 2,
    type: '中转仓/前置仓',
    location: '广州花都',
    capabilities: ['支持多主体货权', '支持无进项货物', '可配合1039报关', '可出具规范出仓记录'],
    description: '灵活中转存储，适合跨境电商预备货'
  },
  {
    id: 3,
    type: '报关协同仓',
    location: '广州南沙',
    capabilities: ['支持多主体货权', '支持无进项货物', '可配合1039报关', '可出具规范出仓记录'],
    description: '与报关行深度协同，合规操作标准化'
  }
];